/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */
import $ from 'jquery';
import { toLocalizedRiotUrl } from './../utils/language';

function postJson(url, draft) {
    return $.ajax({
        type: 'POST',
        contentType: 'application/json',
        url: url,
        data: JSON.stringify(draft),
        dataType: 'json'
    });
}

export default new (function() {
    var _request = null;

    function getCampaignCode(campaignCode, categoryId, brandAttributeValues) {
        var deferred = $.Deferred();

        var requestData = {
            code: campaignCode,
            selectedCategories: categoryId ? [categoryId] : [],
            selectedBrandAttributes: brandAttributeValues
        };

        if (_request) {
            _request.abort();
        }

        _request = postJson(
            toLocalizedRiotUrl('/selling/api/campaign'),
            requestData
        )
            .success(function(data) {
                deferred.resolve(data);
            })
            .error(function(reason) {
                if (reason.statusText === 'abort') {
                    deferred.reject('aborted');
                } else {
                    deferred.reject('Could not get the campaignCode');
                }
            })
            .done(function() {
                _request = null;
            });

        return deferred.promise();
    }

    this.validate = function(campaignCode, categoryId, brandAttributeValues) {
        var deferred = $.Deferred();

        getCampaignCode(campaignCode, categoryId, brandAttributeValues)
            .then(function(data) {
                var result = {};
                result.campaignCodeValid = data.validation.isValid;
                result.validationDisplayMessage = data.validation.message;
                result.hasEnded = data.validation.hasEnded;
                if (data.campaign) {
                    result.campaignCode = data.campaign.code;
                    result.campaignCodeId = data.campaign.id;
                    result.campaignCodeMessage = data.campaign.description;
                    result.isCustomLengthFeeFree =
                        data.campaign.isCustomLengthFeeFree;
                    result.isUnsoldFeeFree = data.campaign.isUnsoldFeeFree;
                    result.provisionFactor = data.campaign.provisionFactor;
                    result.discountFactor = data.campaign.discountFactor;
                    result.maxFeeCap = data.campaign.maxFeeCap;
                    result.bannerMobileImageUrl =
                        data.campaign.bannerMobileImageUrl;
                    result.bannerTabletImageUrl =
                        data.campaign.bannerTabletImageUrl;
                    result.bannerDesktopImageUrl =
                        data.campaign.bannerDesktopImageUrl;
                }
                deferred.resolve(result);
            })
            .fail(function(reason) {
                if (reason === 'aborted') {
                    deferred.reject(reason);
                } else {
                    deferred.reject('Kampanjkoden var inte giltig');
                }
            });
        return deferred.promise();
    };
})();
